import { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setScrollY, setIsMenuOpen, setOpacityBurger, setIsLargeScreen } from "../../store/slices/headerSlice";
import { Imgs } from "../../img/Imgs/Imgs";
import { Spin as Hamburger } from "hamburger-react";
import Lang from "../Lang/Lang";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Header = () => {
  const selectedLanguages = useSelector(selectedLanguage);
  const dispatch = useDispatch();
  const { scrollY, isMenuOpen, opacityBurger, isLargeScreen } = useSelector((state) => state.header);

  
  useEffect(() => {
    const handleScroll = () => {
      const sectionHeight = document.querySelector(".main").offsetHeight - document.querySelector(".header").offsetHeight;
      const opacity = Math.min(window.scrollY / sectionHeight + 0.1, 1);
      dispatch(setOpacityBurger(opacity));
      dispatch(setScrollY(window.scrollY));
    };

    const handleResize = () => {
      dispatch(setIsLargeScreen(window.innerWidth > 1024));
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  const toggleMenu = () => {
    dispatch(setIsMenuOpen());

    if (!isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };

  const closeMenu = () => {
    if (isMenuOpen) {
      dispatch(setIsMenuOpen());
      document.body.style.overflow = "auto";
    }
  };

  return (
    <header
      className="header"
      style={{
        backgroundColor: isMenuOpen ? `rgb(4,5,50,1)` : `rgb(4,5,50,${scrollY === 0 ? 0 : opacityBurger})`,
        padding: isLargeScreen ? (scrollY === 0 ? "30px 20px" : "15px 20px") : "15px 10px",
      }}
    >
      <div className="header__container container">
        <NavLink to="/" onClick={closeMenu}>
          <img src={Imgs.logo} alt="logo" width="120px" />
        </NavLink>
        <ul
          style={{
            height: isMenuOpen ? `${document.querySelector(".header__container ul").scrollHeight + 50}px` : "0px",
            padding: isMenuOpen ? "20px" : "0px",
            borderTop: isMenuOpen ? "1px solid white" : "none",
          }}
        >
          <li>
            <NavLink to="/" onClick={closeMenu}>
              {translations[selectedLanguages].header.title1}
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={closeMenu}>
              {translations[selectedLanguages].header.title2}
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" onClick={closeMenu}>
              {translations[selectedLanguages].header.title3}
            </NavLink>
          </li>
          <li>
            <NavLink to="/templates/websites" onClick={closeMenu}>
              {translations[selectedLanguages].header.title4}
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={closeMenu}>
              {translations[selectedLanguages].header.title5}
            </NavLink>
          </li>
        </ul>
        <div className="right-box">
          <Lang />
          <Link to="/contact">{translations[selectedLanguages].header.button}</Link>
        </div>
        <div className="right-burg">
          {!isLargeScreen && <Lang />}
          <div className="icon" onClick={toggleMenu}>
            <Hamburger color="#fff" toggled={isMenuOpen} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
